<div class="extra-large-screen titration-rechner-screen {{partnerName}}">
    <div class="absolute-loading" *ngIf="showLoading">
        <div class="lds-ripple"><div></div><div></div></div>
    </div>

    <div class="app-header">
        <div class="container-xl">
            <header>
                <div class="header-left">
                    <ng-container [ngSwitch]="partnerName">
                        <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_DEMO">
                            <a class="header-logo" href="/dosis-eq/demo">
                                <img style="width:120px;" src="/images/private/titration/demo/Logo.svg" alt="Logo.svg" />
                            </a>
                        </ng-container>
                        <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_TILRAY">
                            <a class="header-logo" href="/dosis-eq/tilray">
                                <img style="width:120px;" src="/images/private/titration/tilray/Logo.svg" alt="Logo.svg" />
                            </a>
                        </ng-container>
                        <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_HORMOSAN">
                            <a class="header-logo" href="/dosis-eq/hormosan">
                                <img style="width:120px;" src="/images/private/titration/hormosan/Hormosan Logo.svg" alt="Hormosan Logo.svg" />
                            </a>
                        </ng-container>
                        <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_420_PHARMA">
                            <a class="header-logo" href="/dosis-eq/420pharma">
                                <img style="width:120px;" src="/images/private/420pharma/Logo.svg" alt="Logo.svg" />
                            </a>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <a class="header-logo" href="/">
                                <img src="/Copeia.svg" alt="Copeia" />
                            </a>
                        </ng-container>
                    </ng-container>
                    <div class="header-tabs">
                        <div class="header-tab" [class.active]="ActiveTherapieTab==TherapieTabsEnum.STARTEN">
                            <div class="tab-name starten" (click)="onTabChange(TherapieTabsEnum.STARTEN)">Therapie Starten</div>
                        </div>
                        <div class="header-tab" [class.active]="ActiveTherapieTab==TherapieTabsEnum.FORTSETZEN">
                            <div class="tab-name fortsetzen" (click)="onTabChange(TherapieTabsEnum.FORTSETZEN)">Therapie Fortsetzen</div>
                        </div>
                    </div>
                </div>
                <div class="header-right">
                    <ul>
                        <li placement="bottom" ngbTooltip="Neu Laden" (click)="onIconClick('reload')">
                            <img src="/images/icons/Reload_Icon.svg" alt="Reload" />
                        </li>
                        <li class="first" placement="right" ngbTooltip="Info" (click)="onIconClick('info')">
                            <img src="/images/icons/Info.svg" alt="Info" />
                        </li>
                    </ul>
                </div>
            </header>
        </div>
    </div>

    <ng-container [ngSwitch]="ActiveTherapieTab">
        <ng-container *ngSwitchCase="TherapieTabsEnum.STARTEN">
            <div class="therapie-section therapie-starten"></div>
        </ng-container>
        <ng-container *ngSwitchCase="TherapieTabsEnum.FORTSETZEN">
            <div class="therapie-section therapie-fortsetzen"></div>
        </ng-container>
        <ng-container *ngSwitchDefault>

        </ng-container>
    </ng-container>

    <div class="container-xl" *ngIf="productList?.length">
        <div class="product-list-section" [class.active]="productExpanded">
            <div class="product-list-header" (click)="productExpanded=!productExpanded">
                <div>Produktportfolio Übersicht</div>
            </div>
            <div class="product-list-content scrollbar">
                <div class="product-list-block" *ngFor="let product of productList" [class.selected]="product.ProductName==productNameInput">
                    <div class="product-list-block-item">
                        <div class="product-item product-item-sm product-item-image">
                            <img src="/Products/Icon/{{product.Image}}" onerror="this.src ='/NoImg.svg'" />
                        </div>
                        <div class="product-item product-item-title">
                            <div class="item-row w-100">
                                <h6>{{product.ProductName}}</h6>
                            </div>
                            <div class="item-row">
                                <div>THC</div>
                                <h5>{{product.THC || "-"}}</h5>
                                <h6>mg/mL</h6>
                            </div>
                            <div class="item-row">
                                <div>CBD</div>
                                <h5>{{product.CBD || "-"}}</h5>
                                <h6>mg/mL</h6>
                            </div>
                        </div>
                        <div class="product-item">
                            <div class="item-row">
                                <div>PZN</div>
                                <h6>{{product.PZN || "-"}}</h6>
                            </div>
                            <div class="item-row">
                                <div>Inhalt</div>
                                <h6>{{product.Inhalt || "-"}}</h6>
                            </div>
                            <div class="item-row">
                                <div>Trägeröl</div>
                                <h6>{{product.Tragerol || "-"}}</h6>
                            </div>
                        </div>
                        <div class="product-item product-item-sm">
                            <div class="item-row">
                                <div>Apothekeneinkaufpreis</div>
                                <h6>{{product.Apothekeneinkaufpreis || "-"}}</h6>
                            </div>
                            <div class="item-row">
                                <div>Preis THC mg/mL</div>
                                <h6>€ {{product.PreisTHC || "-"}}</h6>
                            </div>
                            <div class="item-row">
                                <div>Preis CBD mg/mL</div>
                                <h6>€ {{product.PreisCBD || "-"}}</h6>
                            </div>
                        </div>
                        <div class="product-item" [ngClass]="{'product-item-pdf':product.PDF}">
                            <div class="pdf-block" *ngIf="product.PDF">
                                <a href="/Products/PDF/{{product.PDF}}" target="_blank">
                                    <ng-container [ngSwitch]="partnerName">
                                        <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_420_PHARMA">
                                            <img src="/images/private/420pharma/download.svg" />
                                        </ng-container>
                                        <ng-container *ngSwitchDefault>
                                            <img src="/download.svg" />
                                        </ng-container>
                                    </ng-container>
                                </a>
                                <div>Download Infoblatt</div>
                            </div>
                        </div>
                    </div>
                    <div class="product-list-checkbox">
                        <div class="checkbox" [class.selected]="product.ProductName==productNameInput" (click)="fnSelectProduct(product.ProductName)">
                            <span></span>
                        </div>
                        <div>Produkt auswählen</div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <ng-container [ngSwitch]="ActiveTherapieTab">
        <ng-container *ngSwitchCase="TherapieTabsEnum.STARTEN">
            <app-titration-therapie-starten [partnerName]="partnerName" [productList]="productList" [productNameInput]="productNameInput" (onChooseProductName)="onChooseProductName($event)" [KolbenpipetteValue]="KolbenpipetteValue" [DosierpumpeValue]="DosierpumpeValue" [thcKonzentrationInput]="thcKonzentrationInput" [thcKonzentrationList]="thcKonzentrationList" [artDerDorierungList]="artDerDorierungList" [verschreibungsmengeList]="verschreibungsmengeList" [D_thcKonzentrationList]="D_thcKonzentrationList" [D_artDerDorierungList]="D_artDerDorierungList" [D_verschreibungsmengeList]="D_verschreibungsmengeList"></app-titration-therapie-starten>
        </ng-container>
        <ng-container *ngSwitchCase="TherapieTabsEnum.FORTSETZEN">
            <app-titration-therapie-fortsetzen [partnerName]="partnerName" [productList]="productList" [productNameInput]="productNameInput" (onChooseProductName)="onChooseProductName($event)" [KolbenpipetteValue]="KolbenpipetteValue" [DosierpumpeValue]="DosierpumpeValue" [thcKonzentrationInput]="thcKonzentrationInput" [thcKonzentrationList]="thcKonzentrationList" [artDerDorierungList]="artDerDorierungList" [verschreibungsmengeList]="verschreibungsmengeList" [D_thcKonzentrationList]="D_thcKonzentrationList" [D_artDerDorierungList]="D_artDerDorierungList" [D_verschreibungsmengeList]="D_verschreibungsmengeList"></app-titration-therapie-fortsetzen>
        </ng-container>
        <ng-container *ngSwitchDefault>
            <div class="container-xl">
                <div class="loading-text">Please wait we are loading data...</div>
            </div>
        </ng-container>
    </ng-container>

    <footer>
        <div class="container-xl">
            <div class="footer">
                <div class="logo">
                    <a href="/">
                        <img src="/Copeia.svg" alt="Copeia" />
                    </a>
                </div>
                <div class="footer-links">
                    <div class="copeia-life">
                        <a href="https://www.copeia.info/">Copeia.info</a>
                    </div>
                    <div class="links">
                        <ul>
                            <li>
                                <a href="mailto:info@copeia.de">Kontakt</a>
                            </li>
                            <li>
                                <a href="/impressum">Impressum</a>
                            </li>
                            <li>
                                <ng-container [ngSwitch]="partnerName">
                                    <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_TILRAY">
                                        <a href="/dosis-eq/tilray/datenschutz">Datenschutz</a>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_HORMOSAN">
                                        <a href="/dosis-eq/hormosan/datenschutz">Datenschutz</a>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="PartnerNamesEnum.DOSIS_EQ_420_PHARMA">
                                        <a href="/dosis-eq/420pharma/datenschutz">Datenschutz</a>
                                    </ng-container>
                                    <ng-container *ngSwitchDefault>
                                        <a href="/datenschutz">Datenschutz</a>
                                    </ng-container>
                                </ng-container>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </footer>

</div>
